import React, { useEffect, useState } from 'react';
import AgreementTable from '../../components/agreementsTable/agreementTable';
import Button from '../../../ui/button/button';
import { unacceptedAgreements } from '../../../../common/services/http/agreementService';
import { useIdentityManager } from '../../../../common/hooks/useIdentityManager';
// @ts-ignore
import logoImg from '../../assets/logo/sanne-logo-black.png';
import useTranslate from '../../../../common/hooks/useTranslate';

// @ts-ignore
import LogoSize from '../../../../common/services/config/brandingStore';
import Logo from '../../../ui/logo/logo';

import './agreements.scss';

const Agreements: React.FC<any> = (props) => {
  const [agreements, setAgreements] = useState([]);
  const identity = useIdentityManager();
  const { t } = useTranslate();

  useEffect(() => {
    unacceptedAgreements()
      .then((r) => {
        setAgreements(r.data);
      })
      .catch((err) => console.log('ERROR: ', err));
  }, []);

  return (
    <div className="agreements-wrapper">
      <div className="agreements-content">
        <div className="agreements-header">
          <div className="logo">
            <Logo logoSource="/branding/logo.png" />
          </div>
        </div>
        <div className="agreements-title">
          <span>{t('AGREEMENTS.NAME')}</span>
        </div>
        <div className="consent-text">
          <span>{t('AGREEMENTS.INFO')}</span>
        </div>
        <AgreementTable {...props} agreements={agreements} />
        <div className="button-group">
          <span>{t('AGREEMENTS.APPROVE')}</span>
          <Button buttonStyle="button-wrapper button-wrapper-oval" handleClick={() => identity.signOut()}>
            {t('AGREEMENTS.LOGOUT')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Agreements;
